var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7414 9.01473C15.9136 4.32845 8.08636 4.32845 3.25863 9.01473C2.85632 9.40526 2.20404 9.40526 1.80173 9.01473C1.39942 8.62421 1.39942 7.99105 1.80173 7.60052C7.43408 2.1332 16.5659 2.1332 22.1983 7.60052C22.6006 7.99105 22.6006 8.62421 22.1983 9.01473C21.796 9.40526 21.1437 9.40526 20.7414 9.01473Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8278 11.8432C14.6093 8.71897 9.3911 8.71897 6.17261 11.8432C5.7703 12.2337 5.11803 12.2337 4.71572 11.8432C4.31341 11.4526 4.31341 10.8195 4.71572 10.4289C8.73882 6.52371 15.2616 6.52371 19.2847 10.4289C19.687 10.8195 19.687 11.4526 19.2847 11.8432C18.8824 12.2337 18.2301 12.2337 17.8278 11.8432Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9139 14.6716C13.3047 13.1095 10.6956 13.1095 9.08634 14.6716C8.68403 15.0621 8.03176 15.0621 7.62945 14.6716C7.22714 14.2811 7.22714 13.6479 7.62945 13.2574C10.0433 10.9142 13.957 10.9142 16.3708 13.2574C16.7731 13.6479 16.7731 14.2811 16.3708 14.6716C15.9685 15.0621 15.3162 15.0621 14.9139 14.6716Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.457 16.0858C14.2616 16.8669 14.2616 18.1332 13.457 18.9142C12.6523 19.6953 11.3478 19.6953 10.5432 18.9142C9.73854 18.1332 9.73854 16.8669 10.5432 16.0858C11.3478 15.3048 12.6523 15.3048 13.457 16.0858Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiX2);
export default __webpack_public_path__ + "static/media/WifiX2.923c0ddff72e155f17c3da5b506d20d1.svg";
export { ForwardRef as ReactComponent };